import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Indiana = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Indiana Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Residential Real Estate Sales Disclosure form required.
        </Text>

        <Text style={styles.listItem}>
          2. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          3.{' '}
          <Text style={styles.underline}>
            Seller's Residential Real Estate Sales Disclosure (Form 46234)
          </Text>{' '}
          – This comprehensive disclosure must be completed by the seller to
          inform the buyer of any known defects or issues.
        </Text>
      </View>
    </View>
  );
};

export default Indiana;
